import { render, staticRenderFns } from "./intelligentBodyManage.vue?vue&type=template&id=f9f5f46a&scoped=true"
import script from "./intelligentBodyManage.vue?vue&type=script&lang=js"
export * from "./intelligentBodyManage.vue?vue&type=script&lang=js"
import style0 from "./intelligentBodyManage.vue?vue&type=style&index=0&id=f9f5f46a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f5f46a",
  null
  
)

export default component.exports